import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteContentProvider } from "./context/SiteContentContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingContact from "./components/FloatingContact";
import Home from "./pages/Home";
import TheStay from "./pages/TheStay";
import RoomDetail from "./pages/RoomDetail";
import Experiences from "./pages/Experiences";
import Dining from "./pages/Dining";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import BookNow from "./pages/BookNow";
import BookingSuccess from "./pages/BookingSuccess";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import About from "./pages/About";
import ContentManager from "./pages/ContentManager";
import Terms from "./pages/legal/Terms";
import Privacy from "./pages/legal/Privacy";
import RefundCancellation from "./pages/legal/RefundCancellation";
import DesertResort from "./pages/landing/jaisalmer/DesertResort";
import NearSamSandDunes from "./pages/landing/jaisalmer/NearSamSandDunes";
import ResortWithPool from "./pages/landing/jaisalmer/ResortWithPool";
import CaveStayLanding from "./pages/landing/jaisalmer/CaveStay";
import HeritageResort from "./pages/landing/jaisalmer/HeritageResort";
import LuxuryResort from "./pages/landing/jaisalmer/LuxuryResort";
import Honeymoon from "./pages/landing/for/Honeymoon";
import Family from "./pages/landing/for/Family";
import Couples from "./pages/landing/for/Couples";
import Groups from "./pages/landing/for/Groups";
import BirthdayAnniversary from "./pages/landing/for/BirthdayAnniversary";
import "./App.css";

function App() {
  return (
    <HelmetProvider>
    <SiteContentProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-void flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/stay" element={<TheStay />} />
              <Route path="/stay/:slug" element={<RoomDetail />} />
              {/* Redirects for renamed room slugs */}
              <Route path="/stay/bamboo-duplex" element={<Navigate to="/stay/heritage-huts" replace />} />
              <Route path="/stay/heritage-cottage" element={<Navigate to="/stay/cascade-cottages" replace />} />
              <Route path="/stay/fiber-suite" element={<Navigate to="/stay/desert-riad-suite" replace />} />
              <Route path="/stay/wooden-room" element={<Navigate to="/stay/cocoon" replace />} />
              <Route path="/stay/king-suite" element={<Navigate to="/stay/grand-quad" replace />} />
              <Route path="/stay/cave-stay" element={<Navigate to="/stay/catacomb-suite" replace />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/dining" element={<Dining />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/book" element={<BookNow />} />
              <Route path="/booking/:bookingId" element={<BookNow />} />
              <Route path="/booking/success" element={<BookingSuccess />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund-cancellation" element={<RefundCancellation />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/cms" element={<ContentManager />} />
              <Route path="/jaisalmer/desert-resort" element={<DesertResort />} />
              <Route path="/jaisalmer/resort-near-sam-sand-dunes" element={<NearSamSandDunes />} />
              <Route path="/jaisalmer/resort-with-pool" element={<ResortWithPool />} />
              <Route path="/jaisalmer/cave-stay" element={<CaveStayLanding />} />
              <Route path="/jaisalmer/heritage-resort" element={<HeritageResort />} />
              <Route path="/jaisalmer/luxury-resort" element={<LuxuryResort />} />
              <Route path="/for/honeymoon" element={<Honeymoon />} />
              <Route path="/for/family" element={<Family />} />
              <Route path="/for/couples" element={<Couples />} />
              <Route path="/for/groups" element={<Groups />} />
              <Route path="/for/birthday-anniversary" element={<BirthdayAnniversary />} />
            </Routes>
          </main>
          <Footer />
          <FloatingContact />
        </div>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
    </SiteContentProvider>
    </HelmetProvider>
  );
}

export default App;
